import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_COACH_AVAILABILITIES_QUERY from 'coaching/queries/GetCoachAvailabilityAndCoachTimezone.gql';
import { GetCoachAvailabilityAndCoachTimezone } from 'coaching/queries/__generated__/GetCoachAvailabilityAndCoachTimezone';

export type Props = {
  coachUuid: string;
  startDateTime: string;
  endDateTime: string;
  children: (props: {
    data?: GetCoachAvailabilityAndCoachTimezone;
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCoachAvailabilitiesAndTimezoneContainer(props: Props) {
  return (
    <Query<GetCoachAvailabilityAndCoachTimezone>
      query={GET_COACH_AVAILABILITIES_QUERY}
      variables={{
        coachUuid: props.coachUuid,
        startDateTime: props.startDateTime,
        endDateTime: props.endDateTime,
      }}>
      {({ loading, error, data }) => {
        return props.children({ data, loading, error });
      }}
    </Query>
  );
}
